import React from 'react';
import styled from 'styled-components';
import PageHeroSection from '../components/hero-section/PageHeroSection';
import IntelliCubixColoredImage from '../assets/general/intellicubix-colored.png';
import Button from '../components/Button';
import AiFirstBusinessApplicationsImage from '../assets/blogs/ai-first-business-applications.webp';
import CustomSoftwareForStartupsImage from '../assets/blogs/custom-software-for-startups.webp';
import DigitalMarketingStrategiesForTheModernBusinessBeyondSocialMediaImage from '../assets/blogs/digital-marketing-strategies-for-the-modern-business-beyond-social-media.webp';
import DataAnalyticsAndMachineLearningTransformingDecisionMakingInBusinessImage from '../assets/blogs/data-analytics-and-machine-learning-transforming-decision-making-in-business.webp';
import TheFutureOfWebAndMobileApplicationDevelopmentImage from '../assets/blogs/the-future-of-web-and-mobile-application-development.webp';
import GenerativeAiContentCreationImage from '../assets/blogs/generative-ai-content-creation.webp';
import { useNavigate } from 'react-router-dom';

const MainContainer = styled.div`
  width: 100%;
  min-height: calc(100vh - 200px);
`;

const MainContent = styled.div`
  width: 100%;
  color: ${(props) => props.theme.colors.white};
  padding: 50px 15px 15px 15px;
  max-width: 1170px;
  margin: 0 auto;
`

const IntelliCubixColored = styled.img`
  width: 350px;
  height: 59px;
  margin-bottom: 30px;
`;

const BlogsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
`

const BlogCard = styled.div`
  width: 100%;
  box-shadow: 0 0 4px 0 ${(props) => props.theme.colors.magenta};
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  transition: all 0.3s ease;
  cursor: pointer;

  &:hover {
    box-shadow: 0 0 10px 0 ${(props) => props.theme.colors.magenta};
  }

  @media (max-width: ${({ theme }) => theme.screens.tablet}) {
    flex-direction: column;
  }
`;

const BlogCardInfo = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const BlogCardImageDesktop = styled.img`
  width: auto;
  height: 190px;
  object-fit: cover;
  display: block;
  /* Vintage-style inner shadow */
  box-shadow: inset 0 0 20px 8px rgba(0, 0, 0, 0.6);

@media (max-width: ${({ theme }) => theme.screens.tablet}) {
    display: none;
  }
`;

const BlogCardImageMobile = styled.img`
  width: 100%;
  height: 190px;
  object-fit: cover;
  display: none;

  /* Stronger vintage-style inner shadow */
  box-shadow: inset 0 0 40px 10px rgba(0, 0, 0, 0.9);

@media (max-width: ${({ theme }) => theme.screens.tablet}) {
    display: block;
  }
`;


const BlogCardTitle = styled.h3`
  font-size: 24px;
  font-weight: 600;
  color: ${(props) => props.theme.colors.white};
  text-align: justify;

  @media (max-width: ${({ theme }) => theme.screens.tablet}) {
    text-align: left;
  }
`;

const BlogCardDescription = styled.p`
  font-size: 16px;
  font-weight: 300;
  color: ${(props) => props.theme.colors.white};
  text-align: justify;
`;


const Blog = () => {
  const navigate = useNavigate();

  // generative-ai-content-creation
  // custom-software-for-startups
  // ai-first-business-applications
  // digital-marketing-strategies-for-the-modern-business-beyond-social-media
  // data-analytics-and-machine-learning-transforming-decision-making-in-business
  // the-future-of-web-and-mobile-application-development

  const blogs = [
    {
      id: 1,
      title: 'How Generative AI is Revolutionizing Content Creation for Businesses',
      description: 'Generative AI is revolutionizing content creation, making it faster, smarter, and more scalable than ever before...',
      image: GenerativeAiContentCreationImage,
      link: 'generative-ai-content-creation',
      // generative-ai-content-creation
    },
    {
      id: 2,
      title: 'Why Custom Software is the Best Investment for Startups and Small Businesses',
      description: 'Off-the-Shelf Software Holding You Back? Time to Go Custom!...',
      image: CustomSoftwareForStartupsImage,
      link: 'custom-software-for-startups',
    },
    {
      id: 3,
      title: 'AI-First Business Applications: A New Era of Digital Transformation',
      description: 'AI is no longer an add-on—it’s at the core of modern business applications. Companies embracing AI-first solutions are seeing massive improvements in automation, customer experience, and data-driven d...',
      image: AiFirstBusinessApplicationsImage,
      link: 'ai-first-business-applications',
    },
    {
      id: 4,
      title: 'Digital Marketing Strategies for the Modern Business: Beyond Social Media',
      description: 'Insights into comprehensive digital marketing strategies that extend beyond social media, emphasizing SEO, content marketing, and email campaigns...',
      image: DigitalMarketingStrategiesForTheModernBusinessBeyondSocialMediaImage,
      link: 'digital-marketing-strategies-for-the-modern-business-beyond-social-media',
    },
    {
      id: 5,
      title: 'Data Analytics and Machine Learning: Transforming Decision-Making in Business',
      description: 'How data analytics and machine learning are revolutionizing business decision-making processes, with real-world examples of success stories...',
      image: DataAnalyticsAndMachineLearningTransformingDecisionMakingInBusinessImage,
      link: 'data-analytics-and-machine-learning-transforming-decision-making-in-business',
    },
    {
      id: 6,
      title: 'The Future of Web and Mobile Application Development: Emerging Technologies and Trends',
      description: 'Exploration of emerging trends and technologies in web and mobile application development...',
      image: TheFutureOfWebAndMobileApplicationDevelopmentImage,
      link: 'the-future-of-web-and-mobile-application-development',
    },
  ];



  return (
    <MainContainer>
      <PageHeroSection pageTitle="Blog" />
      <MainContent>
        <IntelliCubixColored src={IntelliCubixColoredImage} alt="Intellicubix Colored" />
        <BlogsContainer>
          {blogs.map((blog) => (
            <BlogCard key={blog.id} onClick={() => navigate(blog.link, { state: { title: blog.title, image: blog.image, link: blog.link } })}>

              <BlogCardImageMobile src={blog.image} alt={blog.title} />
              <BlogCardInfo>
                <BlogCardTitle>{blog.title}</BlogCardTitle>
                <BlogCardDescription>{blog.description}</BlogCardDescription>
              </BlogCardInfo>
              <BlogCardImageDesktop src={blog.image} alt={blog.title} />
            </BlogCard>
          ))}
        </BlogsContainer>
      </MainContent>
      <Button text="LET’S WORK TOGETHER" />
    </MainContainer>
  );
};

export default Blog;

